/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown>, timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Stitching_VoInputs */



/**
* | output |
* | --- |
* | "Stitching VO Track... {current}/{total} \| {timecode}" |
*
* @param {Audio_Description_Export_Status_Stitching_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_stitching_vo = /** @type {((inputs: Audio_Description_Export_Status_Stitching_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Stitching_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Assemblage de la piste VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`VO-Spur wird zusammengefügt... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cucitura traccia VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сшивание звуковой дорожки... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cosiendo pista VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在拼接旁白音轨... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`VO トラックをステッチしています... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वॉयस ओवर ट्रैक को स्टिच किया जा रहा है... ${i?.current}/${i?.total} | ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Costura da faixa de voz... ${i?.current}/${i?.total} | ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Stitching VO Track... ${i?.current}/${i?.total} | ${i?.timecode}`)
});